




























import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { IJoinedTextItem, IJoinedObject, IJoinedString } from "../../../../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../../../../../../../formatEditor/domain/editableFormat";

@Component
export default class TextJoinItemSelector extends Mixins() {
  @Prop({ default: false })
  shouldShowIndex: boolean;

  @Prop({ default: () => [] as IJoinedTextItem[] })
  items: IJoinedTextItem[];

  @Prop({ default: () => [] as IFormatObjectEditable[] })
  selectionObjects: IFormatObjectEditable[];

  $refs!: {
    table: ElTable,
  };

  toTypeString(row: IJoinedTextItem): string {
    if (row.isObject && this.instanceOfIJoinedObject(row.reference)) {
      const formatObject = this.getFormatObjectEditable(row.reference);
      return formatObject ? formatObject.getTypeName() : "";
    }
    if (!row.isObject && this.instanceOfIJoinedString(row.reference)) {
      return "固定文字";
    }
    return "";
  }

  toKeyString(row: IJoinedTextItem): string {
    if (row.isObject && this.instanceOfIJoinedObject(row.reference)) {
      const formatObject = this.getFormatObjectEditable(row.reference);
      return formatObject && formatObject.getIdentifiableName()
        ? formatObject.getIdentifiableName()
        : row.reference.key;
    }
    if (!row.isObject && this.instanceOfIJoinedString(row.reference)) {
      return row.reference.value;
    }
    return "";
  }

  toIdString(row: IJoinedTextItem): string {
    return row.isObject && this.instanceOfIJoinedObject(row.reference)
      ? row.reference.id ? row.reference.id.toString() : ""
      : "";
  }

  private instanceOfIJoinedObject(instance: any): instance is IJoinedObject {
    return instance;
  }

  private instanceOfIJoinedString(instance: any): instance is IJoinedString {
    return instance;
  }

  private getFormatObjectEditable(row: IJoinedObject): IFormatObjectEditable {
    return this.selectionObjects.find(v => {
      const linkedObject = v.toLinkedObjectIdentifier();
      return linkedObject.type === row.type &&
        linkedObject.id === row.id &&
        linkedObject.key === row.key &&
        linkedObject.subKey === row.subKey;
    });
  }

  @Watch("items")
  onItemsUpdated(newValue: IJoinedTextItem[], oldValue: IJoinedTextItem[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  selectionChange(value: IJoinedTextItem[]): void {}
}
